import * as React from 'react';
import Base from './Base';
const Paragraph = (props, ref) => (<Base ref={ref} {...props} component="div"/>);
export default React.forwardRef(Paragraph);
